import { MaterialUICore } from '@iclinic/design-system';

const { makeStyles } = MaterialUICore;

const useStyles = makeStyles((theme) => ({
  title: {
    color: theme.palette.grey[900],
    fontSize: '1.125rem',
  },
  select: {
    marginTop: `${theme.spacing(2)}px`,
    width: 280,
  },
}));

export default useStyles;
